export default "__VITE_ASSET__RKD0oFS8__"